import React, { ReactNode } from 'react';

export const getTextFromChildren = (children?: ReactNode): string => {
  try {
    if (!children) {
      return '';
    }

    return (
      React.Children.map(children, child => {
        if (typeof child === 'string') {
          return child;
        }
        if (child && React.isValidElement(child)) {
          return getTextFromChildren((child.props as { children?: ReactNode }).children);
        }
      })?.reduce((name, curr) => name || curr, '') ?? ''
    );
  } catch (_ex) {
    return '';
  }
};
